{
  "digital_twin_network": {
    "title": "Impossible de se connecter au jumeau numérique",
    "subtitle": "Faisons quelques vérifications pour voir ce qui ne va pas...",
    "title_success": "Test de connexion réussi",
    "subtitle_success": "Pour vous connecter au Digital Twin, retournez sur la carte et cliquez sur le bouton Digital Twin",
    "support_1": " Veuillez consulter le ",
    "documentation": "Documentation",
    "support_2": " pour les paramètres de pare-feu et de connexion. Si le problème persiste, veuillez contacter le support à l'adresse",
    "iventis_card": {
      "title": "Iventis",
      "subtitle": "Principaux services d'application"
    },
    "websocket_card": {
      "title": "Websocket",
      "subtitle": "Établissez la connexion Digital Twin"
    },
    "webRTC_card": {
      "title": "WebRTC",
      "subtitle": "Communication vidéo et en temps réel avec le jumeau numérique"
    },
    "return_to_map": "Retourner à la carte",
    "recommended_actions": {
      "title": "Action suggérée",
      "iventis": "Vérifiez votre connexion Internet et réessayez. Si le problème persiste, veuillez contacter le support à l'adresse",
      "websocket": "Vérifiez les paramètres de votre réseau et de votre pare-feu pour vous assurer que les connexions Websocket sont autorisées et qu'aucune règle de pare-feu ne bloque la connexion à iventis.com. Si le problème persiste, veuillez contacter le support à l'adresse",
      "webRTC": "Vérifiez les paramètres de votre réseau et de votre pare-feu pour vous assurer que les connexions WebRTC sont autorisées et que les ports 19302, 19303 et 10000-65535 sont ouverts et autorisent les requêtes STUN et TURN vers iventis.com. Si le problème persiste, veuillez contacter le support à l'adresse"
    },
    "testing": "Pour tester votre connexion, veuillez patienter..."
  },
  "model_preview": {
    "toggle_bounding_box": "Basculer le cadre de délimitation",
    "bounding_box_check": "Vérifiez que le modèle s'insère dans le cadre de sélection",
    "bounding_box_check_dimensions": "Vérifiez que le modèle s'insère dans le cadre de délimitation et que les dimensions sont correctes",
    "dimensions_warning": "La modification des dimensions ne modifie pas la taille du modèle. Ces valeurs sont utilisées comme dimensions de référence lors de l'application d'un dimensionnement personnalisé dans les styles de couche.",
    "length_axis_colour": "Axe rouge",
    "width_axis_colour": "Axe vert",
    "height_axis_colour": "Axe bleu",
    "advanced_options": "Avancé"
  },
  "data_table_filter": {
    "operator": "Opérateur"
  },
  "map_settings": {
    "interface_style": "Style d'interface cartographique",
    "compressed": "compressé",
    "spacious": "Spacieux"
  }
}